export default function () {
  document.addEventListener('alpine:initialized', () => {
    // show scroll to top button
    window.onscroll = function() {
      const scrollOffset = 400;
      const scrollButton = document.querySelector('.page-return-top');
      if (scrollButton) {
        if (document.body.scrollTop > scrollOffset || document.documentElement.scrollTop > scrollOffset) {
          scrollButton.classList.add('active');
        } else {
          scrollButton.classList.remove('active');
        }
      }
    };

    // scroll to top
    const scrollButton = document.querySelector('.page-return-top');
    if (scrollButton) {
      scrollButton.addEventListener('click', scrollToTop);
    }
  });

  function scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const scrollButton = document.querySelector('.page-return-top');
    if (scrollButton) {
      scrollButton.classList.remove('active');
    }
  }
}
